var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 10,
    fill: "#0492C2",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_81)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.75 24.25C33.75 23.6201 34.0002 23.016 34.4456 22.5706C34.891 22.1252 35.4951 21.875 36.125 21.875H39.6875V19.5C39.6875 18.8701 39.4373 18.266 38.9919 17.8206C38.5465 17.3752 37.9424 17.125 37.3125 17.125H15.9375C15.3076 17.125 14.7035 17.3752 14.2581 17.8206C13.8127 18.266 13.5625 18.8701 13.5625 19.5V33.75C13.5625 34.3799 13.8127 34.984 14.2581 35.4294C14.7035 35.8748 15.3076 36.125 15.9375 36.125H33.75V24.25Z",
    fill: "#0492C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.625 38.5V24.25C45.625 22.9383 44.5617 21.875 43.25 21.875H36.125C34.8133 21.875 33.75 22.9383 33.75 24.25V38.5C33.75 39.8117 34.8133 40.875 36.125 40.875H43.25C44.5617 40.875 45.625 39.8117 45.625 38.5Z",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 40.875H23.0625",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 36.125H15.9375C15.3076 36.125 14.7035 35.8748 14.2581 35.4294C13.8127 34.984 13.5625 34.3799 13.5625 33.75V19.5C13.5625 18.8701 13.8127 18.266 14.2581 17.8206C14.7035 17.3752 15.3076 17.125 15.9375 17.125H37.3125C37.9424 17.125 38.5465 17.3752 38.9919 17.8206C39.4373 18.266 39.6875 18.8701 39.6875 19.5V21.875",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 26.625H40.875",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.a8febb6fbdfa308970f4d8fa9ad7650b.svg";
export { ForwardRef as ReactComponent };